export default __webpack_public_path__ + "e4f3b3c300bc75bdfb8534a227b21296.svg";